import { ViewDiv } from "@faro-lotv/app-component-toolbox";
import { Box } from "@mui/material";
import { RefObject, type JSX } from "react";
import {
  MinimapEditButtonProps,
  MinimapEditWaypointsButton,
} from "./minimap-edit-waypoints-button";

export type MinimapOverlayCanvasProps = Pick<
  MinimapEditButtonProps,
  "isContainerHovered" | "isAllowedToEdit" | "isEditing" | "onToggleEditing"
> & {
  /** A ref to the div to use as a tracking element for the MiniMap */
  eventDivRef: RefObject<HTMLDivElement | null>;

  /** The reference to the canvas inside the MiniMap div */
  canvasRef?: RefObject<HTMLCanvasElement | null>;
};

/**
 * @returns The minimap overlay that is placed over the minimap canvas.
 */
export function MinimapOverlayCanvas({
  canvasRef,
  eventDivRef,
  isContainerHovered,
  isAllowedToEdit,
  isEditing,
  onToggleEditing,
}: MinimapOverlayCanvasProps): JSX.Element {
  return (
    <Box
      component="div"
      sx={{ position: "relative", width: "100%", height: "100%" }}
    >
      <Box
        component="canvas"
        ref={canvasRef}
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          pointerEvents: "none",
          borderRadius: 1,
        }}
      />
      <ViewDiv
        eventDivRef={eventDivRef}
        sx={{ position: "absolute", width: "100%", height: "100%" }}
      >
        <MinimapEditWaypointsButton
          isAllowedToEdit={isAllowedToEdit}
          isContainerHovered={isContainerHovered}
          isEditing={isEditing}
          onToggleEditing={onToggleEditing}
          sx={{ position: "absolute", top: 8, right: 8 }}
        />
      </ViewDiv>
    </Box>
  );
}
